import { componentLoader, componentConfig } from "../../lib/component_initializer";
import { SuggestionPanel } from "./suggestion_panel";

// Registers a ComponentInitializer for SuggestionPanel. Its MutationObserver auto-
// initialises the panel when the experience profile's markup is injected — in the online
// app and the native webview the profile is rendered client-side from the Handlebars
// template, so the panel does not exist at DOM-ready.
export const suggestionPanelLoader = function (options = {}) {
  componentLoader(
    componentConfig(SuggestionPanel, SuggestionPanel.config.componentTypeKey, SuggestionPanel.config.baseHtmlClass),
    options,
  );
};
